import { Component, enableProdMode } from '@angular/core';

if (process.env && process.env.ENV === 'production') {
    enableProdMode();
}

@Component({
    selector: 'cfn-app',
    template: `
        <router-outlet ></router-outlet>
        <div id="viewDiv" class="full-height-minus-footer ng-view">
        </div>
    `
})
export class AppComponent {
}
